// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__vBHB2","errorCode":"ErrorPage_errorCode__+drT6","errorMessage":"ErrorPage_errorMessage__Kxwm5","refreshButton":"ErrorPage_refreshButton__2FpEx"};